let lastExecuteTime = 0;

/**
 * 是否连续快速执行两次方法
 * @param time  延迟时间
 * @returns {boolean}
 */
export const isFastExecute = (time = 1000) => {
  if (Date.now() - lastExecuteTime < time) {
    return true;
  }
  lastExecuteTime = Date.now();
  return false;
};

export function parseTime(time, cFormat) {
  try {
    if (!time) return time;
  if (arguments.length === 0) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if ((`${time}`).length === 10) date = parseInt(time, 10) * 1000;
    date = new Date(date);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === "a") { return ["一", "二", "三", "四", "五", "六", "日"][value - 1]; }
    if (result.length > 0 && value < 10) {
      value = `0${value}`;
    }
    return value || 0;
  });
  return time_str;
  } catch (e) {
    return time;
  }
}
// 当字符串长度大于size大小，后面加省略号
export function stringSize(value, size) {
  let newValue = value;
  try {
    if (value && value.length > size) {
      newValue = `${value.substr(0, size)}...`;
    }
  } catch (e) {
    console.log("字符串处理错误==>", e);
  }
  return newValue;
}
// json转路径后参数
export function jsonToEqualString(json) {
  const keys = Object.keys(json);
  let valueString = "";
  for (let index = 0; index < keys.length; index++) {
    valueString += `${keys[index]}=${json[keys[index]]}&`;
  }
  return valueString;
}
// 验证是否为数组
export function validArray(rule, value, callback) {
  if (!(Array.isArray(value) || value)) {
    return callback(new Error("请选择课程"));
  }
  return callback();
}

// 格式化JSON
export const formatJson = function (msg) {
  const rep = '~';
  let jsonStr = JSON.stringify(msg, null, rep);
  let str = '';
  for (let i = 0; i < jsonStr.length; i++) {
    const text2 = jsonStr.charAt(i);
    if (i > 1) {
      const text = jsonStr.charAt(i - 1);
      if (rep !== text && rep === text2) {
        str += '';
      }
    }
    str += text2;
  }
  jsonStr = '';
  for (let i = 0; i < str.length; i++) {
    const text = str.charAt(i);
    if (rep === text) { jsonStr += '       '; } else {
      jsonStr += text;
    }
    if (i === str.length - 2) { jsonStr += '\r\n'; }
  }
  return jsonStr;
};
